import api, { apiSetup } from '../api';

apiSetup();

export class TiposFinanciamientoService {
  BASE_URL = '/tipos-financiamiento';

  get() {
    return api.get(this.BASE_URL);
  }
}
